import React from 'react'
import { Icon as DSIcon } from "quorumdesign"
import { connect } from "react-redux"
import { iconTypeCellConnection } from "sheets/selectors/cell-selectors"
import classNames from "classnames"
import PropTypes from "prop-types"

/**
 * A cell in a Sheet, with an icon and label based on a djangioType.
 */
export const IconTypeCell = ({
    icon,
    iconFamily,
    label,
    children,
}) => (
    <span className="fa5-icon-cell">
        <span className={classNames({
            "type-icon": true,
            "rotated": icon === "horizontal-rule",
        })}
        >
            <DSIcon
                icon={icon}
                iconFamily={iconFamily}
                size="lg"
            />
        </span>
        <label className="icon-cell-label">
            {label}
            {children}
        </label>
    </span>
)

IconTypeCell.propTypes = {
    djangioType: PropTypes.object.isRequired,
    /** The enum value used to look up a djangioType definition. */
    value: PropTypes.number.isRequired,
    /** If blank, base the label on the djangioType field "label". Otherwise, use this field name. */
    labelField: PropTypes.string,
    /** If provided, use this icon name instead of the one found in the djangio enum. */
    iconOverride: PropTypes.string,
    children: PropTypes.node,
}

export default connect((state, props) => iconTypeCellConnection(state, props))(IconTypeCell)
